import { useInAppBrowser } from 'App/capacitor';
import { useGetOldAdminAuthorizationCodeQuery } from 'domains/PartnersApps/partnersAppsApi';
import useAdminLinks from './useAdminLinks';

export function useLoggedAdminLink() {
  const { data: authCode, isLoading } = useGetOldAdminAuthorizationCodeQuery();
  const { getOldAdminLink } = useAdminLinks();
  const openInAppBrowser = useInAppBrowser();

  const getLoggedAdminLink = (oldAdminPath: string) =>
    `${getOldAdminLink(
      'auth/login',
    )}?code=${authCode}&login_to=${getOldAdminLink(
      oldAdminPath,
    )}&for_admin_app=true`;

  const goToLoggedAdminLink = async (
    oldAdminPath: string,
    onClick?: () => void,
  ) => {
    const oldAdminLink = getLoggedAdminLink(oldAdminPath);
    onClick?.();

    await openInAppBrowser(oldAdminLink);
  };

  return {
    goToLoggedAdminLink,
    getLoggedAdminLink,
    isLoading,
  };
}
